<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">
          Delete Support Agent
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <p class="text-body-1">
            Are you sure you want to delete this support agent? This will
            deactivate the agent.
          </p>
          <p v-if="agent" class="text-body-2 mt-2 font-weight-medium">
            Agent: {{ agent.agent_name || agent.agent_email_id }}
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            variant="text"
            @click="handleClose"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="handleDelete"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_support_agent } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "DeleteSupportAgentDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: Boolean,
    agent:  Object,
  },
  emits: ["update:modelValue", "deleted"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        // Reset when dialog closes
      }
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleDelete() {
      this.loading = true;

      try {
        const input = {
          agent_id: this.agent.agent_id || this.agent.id || "",
          agent_status: "DEACTIVE",
        };

        const response = await client.graphql({
            query: edit_support_agent,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(response.data.edit_support_agent);

        if (responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Support agent deleted successfully",
            color: "success",
          };
          this.$emit("deleted", 0);
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message || "Failed to delete support agent",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error deleting support agent:", error);
        this.snackbar = {
          show: true,
          message: error.message || "Failed to delete support agent",
          color: "error",
        };
      }
    },
  },
};
</script>

<style scoped>
</style>
